// ========================================
// COMPANY CONFIGURATION
// ========================================
// Update all your company details here in one place
// These values will be used throughout the website

const companyConfig = {
  // Company Basic Info
  company: {
    name: "Time2Find",
    tagline: "Empowering enterprises through innovative SAP solutions",
    description: "25 years of delivering secure, scalable enterprise SAP solutions across the globe.",
    foundedYear: 2000,
    experience: "25+",
  },

  // Contact Information
  contact: {
    email: "info@time2find.com",
    phone: "+1 856 981 1994",
    phoneRaw: "+1 856 981 1994", // Used for tel: links
    address: "Honolulu,HI 96813, USA",
    fullAddress: "1001 Bishop St, Ste 2685A, Honolulu, HI 96813, USA",
    whatsapp: "+1 856 981 1994", // WhatsApp number (with country code, no spaces or special chars)
    whatsappMessage: "Hi! I'm interested in learning more about your SAP solutions and services.", // Pre-filled message
  },

  // Google reCAPTCHA Configuration
  recaptcha: {
    siteKey: "6LfcSC4sAAAAAFS6ZEjuwsTtMX9N453zrvH9oeiO", // ✅ Real Site Key - Registered at https://www.google.com/recaptcha/admin
    enabled: true, // ✅ ENABLED - Spam protection active on all forms
  },

  // Cookie Consent Configuration
  cookieConsent: {
    title: "We Value Your Privacy",
    message: "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    learnMoreText: "Learn more",
    learnMoreLink: "/privacy-policy",
    acceptButtonText: "Accept All",
    declineButtonText: "Decline",
    showDelay: 1000, // Delay in milliseconds before showing banner (1000 = 1 second)
  },

  // Contact Page Configuration
  contactPage: {
    hero: {
      title: "Contact Us",
      highlightWord: "Us", // The word to highlight in blue
      subtitle: "Ready to transform your business? Get in touch with our experts to discuss your IT challenges and discover how we can help you achieve your goals."
    },
    getInTouch: {
      title: "Get in Touch",
      subtitle: "Choose the method that works best for you. Our team is standing by to help.",
      methods: [
        {
          icon: "fa-phone-alt",
          title: "Phone Support",
          description: "Speak directly with our experts. Available Monday to Friday, 9 AM - 6 PM EST.",
          detail: "+1 856 981 1994"
        },
        {
          icon: "fa-envelope",
          title: "Email Us",
          description: "Send us an email and we'll respond within 24 hours on business days.",
          detail: "info@time2find.com"
        },
        {
          icon: "fa-comments",
          title: "Live Chat",
          description: "Chat with our support team in real-time for quick answers to your questions.",
          detail: "Start Chat Now"
        },
        {
          icon: "fa-calendar-alt",
          title: "Schedule a Meeting",
          description: "Book a consultation with our team to discuss your IT needs in detail.",
          detail: "Book Appointment"
        }
      ]
    },
    globalOffices: {
      title: "Global Offices",
      subtitle: "With offices around the world, we're always nearby to provide local support and expertise.",
      offices: [
        {
          location: "Hawaii",
          address: "1001 Bishop St, Ste 2685A",
          city: "Honolulu, HI 96813",
          phone: "+1 856 981 1994"
        },
        {
          location: "Kerala",
          address: "2nd Floor, Kulathakkal Building",
          city: "Pathanamthitta, Kerala 689647",
          phone: "+91 87149 74559"
        },
       
        
      ]
    },
    form: {
      title: "Send us a message",
      icon: "fa-comment-dots",
      successMessage: "Message sent successfully! We'll get back to you soon.",
      errorMessage: "Error sending message. Please try again.",
      fields: {
        fullName: { label: "Full Name", placeholder: "John Doe" },
        email: { label: "Email Address", placeholder: "john@company.com" },
        company: { label: "Company Name", placeholder: "Your Company" },
        phone: { label: "Phone Number", placeholder: "+1 (555) 123-4567" },
        service: { label: "Service Interested In", placeholder: "Select a service" },
        message: { label: "Your Message", placeholder: "Tell us about your project or inquiry..." }
      },
      submitButton: "Send Message",
      loadingButton: "Sending..."
    },
    serviceOptions: [
      "Data Analytics",
      "Cloud ERP",
      "Cyber Security",
      "SAP Implementation",
      "Quality Assurance",
      "IoT Solutions",
      "Project Management",
      "Human Capital Management",
      "Business Applications",
      "SAP Business Network",
      "Transformation Management",
      "Data and Analytics",
      "Other"
    ]
  },

  // Social Media Links
  social: {
    linkedin: "https://www.linkedin.com/in/time2find/",
    facebook: "https://www.facebook.com/search/top?q=time2find",
    instagram: "https://www.instagram.com/t2fllc/",
  },

  // Statistics
  stats: {
    clients: "50+",
    uptime: "99.9%",
    countries: "25+",
    successRate: "98%",
    security: "100%",
  },

  // Services Configuration
  services: [
    {
      id: 1,
      slug: "data-analytics",
      icon: "fas fa-chart-line",
      title: "Data Analytics",
      shortDescription: "Transform raw data into actionable insights with advanced analytics, machine learning, and real-time visualization.",
      fullDescription: "Unlock the power of your data with comprehensive analytics solutions. We help organizations leverage big data processing, machine learning models, predictive analytics, and real-time visualization to drive strategic decision-making and business growth.",
      features: [
        "Big data processing and analytics",
        "Machine learning and AI implementation",
        "Predictive analytics and forecasting",
        "Business intelligence dashboards",
        "Data warehousing and ETL solutions",
        "Real-time analytics and reporting",
        "Data visualization and storytelling",
        "Advanced statistical analysis"
      ],
      benefits: [
        "Make data-driven decisions faster",
        "Identify trends and patterns",
        "Improve operational efficiency",
        "Reduce costs through insights"
      ],
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80",
    },
    {
      id: 2,
      slug: "cloud-erp",
      icon: "fas fa-cloud",
      title: "Cloud ERP",
      shortDescription: "Modernize your enterprise with cloud-based ERP solutions for seamless business operations and scalability.",
      fullDescription: "Transform your business operations with cutting-edge cloud ERP solutions. We provide comprehensive implementation, migration, and optimization services for leading platforms like SAP S/4HANA Cloud, Oracle Cloud ERP, and Microsoft Dynamics 365.",
      features: [
        "Cloud ERP implementation and deployment",
        "ERP system migration and upgrade",
        "Multi-cloud ERP architecture",
        "Integration with existing systems",
        "Custom module development",
        "ERP performance optimization",
        "24/7 cloud ERP support",
        "Training and change management"
      ],
      benefits: [
        "Reduced infrastructure costs",
        "Improved scalability and flexibility",
        "Real-time business insights",
        "Enhanced collaboration"
      ],
      image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1920&q=80",
    },
    {
      id: 3,
      slug: "cybersecurity",
      icon: "fas fa-shield-alt",
      title: "Cyber Security",
      shortDescription: "Protect your digital assets with enterprise-grade security solutions and 24/7 threat monitoring.",
      fullDescription: "Safeguard your organization against evolving cyber threats with our comprehensive security services. From advanced threat intelligence to zero-trust architecture, we provide end-to-end protection for your digital infrastructure.",
      features: [
        "Security risk assessment and auditing",
        "Advanced threat detection and prevention",
        "24/7 Security Operations Center (SOC)",
        "Incident response and forensics",
        "Zero-trust architecture implementation",
        "Compliance management (ISO, GDPR, HIPAA)",
        "Security awareness training",
        "Penetration testing and vulnerability assessment"
      ],
      benefits: [
        "Protect sensitive data",
        "Prevent costly breaches",
        "Ensure regulatory compliance",
        "Build customer trust"
      ],
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1920&q=80",
    },
    {
      id: 4,
      slug: "sap-implementation",
      icon: "fas fa-cogs",
      title: "SAP Implementation",
      shortDescription: "Streamline operations with end-to-end SAP S/4HANA implementation and intelligent process optimization.",
      fullDescription: "Maximize your SAP investment with expert implementation services. Our certified SAP consultants deliver seamless S/4HANA deployments, legacy system migrations, and continuous optimization to drive operational excellence.",
      features: [
        "SAP S/4HANA implementation",
        "Business process re-engineering",
        "Legacy SAP ECC migration",
        "SAP RISE implementation",
        "Custom SAP development (ABAP, Fiori)",
        "SAP integration services",
        "SAP Basis administration",
        "Ongoing SAP support and maintenance"
      ],
      benefits: [
        "Streamlined business processes",
        "Real-time operational insights",
        "Reduced IT complexity",
        "Faster time-to-market"
      ],
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80",
    },
    {
      id: 5,
      slug: "quality-assurance",
      icon: "fas fa-check-circle",
      title: "Quality Assurance",
      shortDescription: "Ensure flawless software delivery with comprehensive testing, automation, and quality validation.",
      fullDescription: "Deliver bug-free, high-performance software with our comprehensive QA services. We implement automated testing frameworks, continuous integration, and rigorous quality validation to ensure your applications meet the highest standards.",
      features: [
        "Automated testing frameworks (Selenium, Cypress)",
        "Performance and load testing",
        "Security and penetration testing",
        "Mobile app testing (iOS, Android)",
        "API and integration testing",
        "CI/CD pipeline integration",
        "Test strategy and planning",
        "Quality metrics and reporting"
      ],
      benefits: [
        "Faster release cycles",
        "Reduced production bugs",
        "Improved user satisfaction",
        "Lower maintenance costs"
      ],
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80",
    },
    {
      id: 6,
      slug: "iot-solutions",
      icon: "fas fa-wifi",
      title: "IoT Solutions",
      shortDescription: "Build intelligent ecosystems with Industrial IoT platforms and smart automation for Industry 4.0.",
      fullDescription: "Embrace the future with Industrial IoT solutions that connect devices, optimize operations, and enable predictive maintenance. Our IoT platform integrates edge computing, real-time monitoring, and advanced analytics for smart manufacturing and operations.",
      features: [
        "Industrial IoT platform development",
        "Edge computing infrastructure",
        "Real-time device monitoring and control",
        "Smart automation systems",
        "IoT security and device management",
        "Predictive maintenance solutions",
        "Sensor integration and data collection",
        "IoT analytics and visualization"
      ],
      benefits: [
        "Optimize asset performance",
        "Reduce downtime",
        "Enable predictive maintenance",
        "Improve operational efficiency"
      ],
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1920&q=80",
    },
    {
      id: 7,
      slug: "project-management",
      icon: "fas fa-tasks",
      title: "Project Management",
      shortDescription: "Deliver projects on time and within budget with proven methodologies and expert program management.",
      fullDescription: "Ensure project success with our enterprise project management services. We apply industry-leading methodologies like Agile, Scrum, and PMI standards to deliver complex IT projects on time, within budget, and to specification.",
      features: [
        "Agile and Scrum project management",
        "PMO setup and governance",
        "Project planning and scheduling",
        "Risk management and mitigation",
        "Resource allocation and optimization",
        "Stakeholder management",
        "Budget and cost control",
        "Project portfolio management (PPM)"
      ],
      benefits: [
        "Improved project success rates",
        "Better resource utilization",
        "Enhanced stakeholder communication",
        "Reduced project risks"
      ],
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=80",
    },
    {
      id: 8,
      slug: "human-capital-management",
      icon: "fas fa-users",
      title: "Human Capital Management",
      shortDescription: "Optimize workforce management with integrated HCM solutions for talent acquisition and employee engagement.",
      fullDescription: "Transform your HR operations with comprehensive Human Capital Management solutions. From talent acquisition to performance management, we help organizations optimize their workforce with cutting-edge HCM platforms and strategies.",
      features: [
        "HCM system implementation (SAP SuccessFactors, Workday)",
        "Talent acquisition and recruitment automation",
        "Performance and goal management",
        "Learning and development platforms",
        "Workforce analytics and planning",
        "Payroll and benefits administration",
        "Employee self-service portals",
        "Succession planning and talent management"
      ],
      benefits: [
        "Attract and retain top talent",
        "Improve employee engagement",
        "Streamline HR processes",
        "Data-driven workforce decisions"
      ],
      image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1920&q=80",
    },
    {
      id: 9,
      slug: "business-applications",
      icon: "fas fa-briefcase",
      title: "Business Applications",
      shortDescription: "Accelerate digital transformation with custom business applications and low-code development platforms.",
      fullDescription: "Empower your business with custom applications tailored to your unique processes. We develop scalable, cloud-native business applications using modern technologies and low-code platforms to accelerate digital transformation.",
      features: [
        "Custom application development",
        "Low-code/no-code platforms (Power Apps, Mendix)",
        "Business process automation",
        "Legacy application modernization",
        "API development and integration",
        "Mobile business apps",
        "Workflow automation",
        "Application maintenance and support"
      ],
      benefits: [
        "Faster time-to-market",
        "Reduced development costs",
        "Improved business agility",
        "Enhanced user experience"
      ],
      image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=1920&q=80",
    },
    {
      id: 10,
      slug: "sap-business-network",
      icon: "fas fa-network-wired",
      title: "SAP Business Network",
      shortDescription: "Optimize supply chain collaboration with SAP Ariba, integrated procurement, and intelligent spend management.",
      fullDescription: "Transform your supply chain and procurement processes with SAP Business Network (SAP Ariba). We help organizations achieve end-to-end visibility, optimize supplier collaboration, and drive intelligent spend management across the entire procurement lifecycle.",
      features: [
        "SAP Ariba implementation",
        "Supplier onboarding and management",
        "Procurement automation",
        "Contract lifecycle management",
        "Sourcing and RFx management",
        "Spend analysis and visibility",
        "Supplier risk management",
        "Integration with SAP S/4HANA"
      ],
      benefits: [
        "Reduce procurement costs",
        "Improve supplier collaboration",
        "Increase process efficiency",
        "Better spend visibility"
      ],
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1920&q=80",
    },
    {
      id: 11,
      slug: "transformation-management",
      icon: "fas fa-exchange-alt",
      title: "Transformation Management",
      shortDescription: "Drive organizational change with strategic transformation consulting and digital innovation roadmaps.",
      fullDescription: "Navigate complex business transformations with confidence. Our transformation management services combine strategic consulting, change management, and technology enablement to help organizations successfully evolve in the digital age.",
      features: [
        "Digital transformation strategy",
        "Change management and adoption",
        "Business process transformation",
        "Technology roadmap development",
        "Innovation workshops and ideation",
        "Organizational design and restructuring",
        "Cultural transformation programs",
        "Transformation measurement and KPIs"
      ],
      benefits: [
        "Accelerate digital adoption",
        "Minimize transformation risks",
        "Increase employee buy-in",
        "Achieve strategic goals faster"
      ],
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80",
    },
    {
      id: 12,
      slug: "data-and-analytics",
      icon: "fas fa-database",
      title: "Data and Analytics",
      shortDescription: "Build enterprise data platforms with data governance, master data management, and advanced analytics.",
      fullDescription: "Create a data-driven organization with comprehensive data and analytics services. We help build enterprise data platforms, implement data governance frameworks, and enable advanced analytics capabilities for better business outcomes.",
      features: [
        "Enterprise data platform architecture",
        "Data governance and quality management",
        "Master data management (MDM)",
        "Data lake and warehouse solutions",
        "Advanced analytics and AI/ML",
        "Self-service BI and analytics",
        "Data migration and integration",
        "Cloud data platform (Azure, AWS, GCP)"
      ],
      benefits: [
        "Single source of truth",
        "Improved data quality",
        "Faster insights",
        "Better compliance"
      ],
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80",
    },
  ],

  // Images Configuration
  images: {
    logo: "/images/logo.png",
    hero: {
      laptop: "/images/hero/laptop-dashboard.svg",
      background: "/images/hero/background.svg",
    },
    about: {
      office: "/images/about/office-meeting.svg",
    },
    clients: [
      "/images/clients/client-1.png",
      "/images/clients/client-2.png",
      "/images/clients/client-3.png",
      "/images/clients/client-4.png",
      "/images/clients/client-5.png",
      "/images/clients/client-6.png",
      "/images/clients/client-7.png",
      "/images/clients/client-8.png",
      "/images/clients/client-9.png",
      "/images/clients/client-10.png",
      "/images/clients/client-11.png",
      "/images/clients/client-12.png",
      "/images/clients/client-13.png",
      "/images/clients/client-14.png",
      "/images/clients/client-15.png",
      "/images/clients/client-16.png",
      "/images/clients/client-17.png",
      "/images/clients/client-18.png",
      "/images/clients/client-19.png",
      "/images/clients/client-20.png",
      "/images/clients/client-21.png",
      "/images/clients/client-22.png",
      "/images/clients/client-23.png",
      "/images/clients/client-24.png",
      "/images/clients/client-25.png",
      "/images/clients/client-26.png",
      "/images/clients/client-27.png",
      "/images/clients/client-28.png",
      "/images/clients/client-29.png",
      "/images/clients/client-30.png",
    ],
  },

  // Twilio Configuration (will use environment variables)
  // Don't put actual credentials here - use .env file
  twilio: {
    enabled: true, // Set to true when Twilio is configured
    notificationPhone: "+1234567890", // Your phone number to receive notifications
  },

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Time2Find for SAP?",
    subtitle: "Your trusted SAP implementation and consulting partner",
    reasons: [
      {
        id: 1,
        icon: "fas fa-certificate",
        title: "SAP Certified Experts",
        description: "Team of SAP-certified consultants with 25+ years of experience in S/4HANA, ECC, and SAP modules."
      },
      {
        id: 2,
        icon: "fas fa-cogs",
        title: "End-to-End Implementation",
        description: "Complete SAP lifecycle support from requirement analysis to go-live and post-production support."
      },
      {
        id: 3,
        icon: "fas fa-cloud-upload-alt",
        title: "SAP Cloud Migration",
        description: "Seamless migration to SAP S/4HANA Cloud with minimal downtime and maximum ROI."
      },
      {
        id: 4,
        icon: "fas fa-puzzle-piece",
        title: "Custom SAP Solutions",
        description: "Tailored SAP modules (FI/CO, MM, SD, PP, HR) configured to your unique business processes."
      },
      {
        id: 5,
        icon: "fas fa-sync-alt",
        title: "SAP Integration",
        description: "Expert integration of SAP with third-party systems, APIs, and legacy applications."
      },
      {
        id: 6,
        icon: "fas fa-chart-line",
        title: "AI SAP",
        description: "50+ successful SAP implementations with 98% client satisfaction and average 40% efficiency gains."
      }
    ]
  },

  // Customer Reviews / Testimonials
  testimonials: {
    title: "What Our Clients Say",
    subtitle: "Trusted by industry leaders worldwide",
    reviews: [
      {
        id: 1,
        name: "John Anderson",
        position: "CTO, Global Tech Solutions",
        company: "Fortune 500 Company",
        rating: 5,
        review: "Time2Find transformed our entire IT infrastructure. Their cloud migration expertise saved us 40% in operational costs while improving system reliability. Exceptional team!"
      },
      {
        id: 2,
        name: "Sarah Mitchell",
        position: "VP of Engineering, FinanceCore",
        company: "Leading Financial Institution",
        rating: 5,
        review: "Outstanding cybersecurity implementation. Their team identified vulnerabilities we didn't know existed and implemented robust solutions. Our security posture has never been stronger."
      },
      {
        id: 3,
        name: "Michael Chen",
        position: "Director of IT, Healthcare Plus",
        company: "Healthcare Provider",
        rating: 5,
        review: "The SAP implementation was flawless. Time2Find's expertise in healthcare compliance and process optimization delivered results beyond our expectations. Highly recommended!"
      }
      
    ]
  },

  // CEO/Founder Section
  ceoFounder: {
    name: "Stanley John",
    title: "CEO & Founder",
    image: "/images/about/ceo-photo.jpg", // Add your CEO image here
    quote: "Our vision is to empower businesses worldwide with cutting-edge technology solutions that drive real transformation and sustainable growth.",
    bio: "With over 25 years of experience in enterprise technology, Time2Find with a mission to bridge the gap between business ambitions and technological reality. Under his leadership, the company has grown from a small startup to a global IT consulting powerhouse, serving Fortune 500 companies across six continents.",
    achievements: [
      "Founded Time2Find in 2000",
      "Led 500+ successful digital transformations",
      "Recognized as Top 10 IT Leaders by Tech Magazine",
      "Speaker At global sap teched in 2006,2010,2016,2022,2024"
    ],
    socialLinks: {
      linkedin: "https://linkedin.com/in/johnsmith",
      twitter: "https://twitter.com/johnsmith"
    }
  },

  // Who We Are Section
  whoWeAre: {
    title: "Who We Are",
    subtitle: "Delivering excellence through our unique approach and talented people",
    cards: [
      {
        icon: "fa-sync-alt",
        title: "Our Process",
        color: "#FDE68A",
        description: [
          "Time2Find has fine-tuned a global delivery model for services and product development organization.",
          "Our resource management team works tirelessly to deliver the talents for your business needs.",
          "Our methodology and guidelines are flexible to suit our customer business requirements."
        ]
      },
      {
        icon: "fa-user-graduate",
        title: "Our People",
        color: "#D1D5DB",
        description: [
          "Our people are well trained, experienced and are highly talented individuals. Our hiring program enables us to recruit the best talents from around the world to meet customers demand.",
          "Our people are dedicated to realizing our client's business vision and committed to strive relentlessly to surpass our customer expectations.",
          "Our people have the relevant functional expertise to meet the business expectations of various industry verticals and the right skills to develop world class business solutions."
        ]
      },
      {
        icon: "fa-desktop",
        title: "Our Focus",
        color: "#D1FAE5",
        description: [
          "We primarily focuses on driving business value to our customers by providing end-to-end solutions that leverage technology, and to provide best of breed products.",
          "Our team of consultants' pride in building world-class applications. We work closely with our customers to maximize their business ROI by building robust applications, optimized processes, best practices and predictive business intelligence."
        ]
      },
      {
        icon: "fa-handshake",
        title: "Our Commitment",
        color: "#FDE68A",
        description: [
          "Time2Find is committed to creating maximum business value by providing the best performance and price model.",
          "Our people are dedicated and passionate towards delivering consistent performance on time and on budget.",
          "We strive to make our customer succeed."
        ]
      }
    ]
  },

  // SAP Solutions & Services Section
  sapSolutions: {
    title: "Our SAP Solutions & Services",
    subtitle: "Comprehensive SAP expertise across traditional and new wave technologies",
    traditional: {
      title: "Traditional",
      modules: [
        // Functional Modules (first 5)
        { name: "FICO", fullName: "Financial Accounting & Controlling", icon: "fa-calculator", type: "Functional" },
        { name: "SD", fullName: "Sales & Distribution", icon: "fa-shopping-cart", type: "Functional" },
        { name: "PP", fullName: "Production Planning", icon: "fa-industry", type: "Functional" },
        { name: "BI", fullName: "Business Intelligence", icon: "fa-chart-line", type: "Functional" },
        { name: "HCM", fullName: "Human Capital Management", icon: "fa-user-tie", type: "Functional" },
        // Technical Modules (last 5)
        { name: "HANA", fullName: "High-Performance Analytics", icon: "fa-database", type: "Technical" },
        { name: "ABAP", fullName: "Advanced Business Application Programming", icon: "fa-code", type: "Technical" },
        { name: "BASIS", fullName: "System Administration", icon: "fa-server", type: "Technical" },
        { name: "MM", fullName: "Materials Management", icon: "fa-boxes", type: "Technical" },
        { name: "HR", fullName: "Human Resources", icon: "fa-users", type: "Technical" }
      ]
    },
    newWave: {
      title: "New Wave",
      services: [
        {
          number: "01",
          title: "SAP HANA, S/4 HANA, & C/4 HANA",
          color: "#10B981",
          gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)"
        },
        {
          number: "02",
          title: "SAP BI, BW4HANA, & BPC",
          color: "#84CC16",
          gradient: "linear-gradient(135deg, #84CC16 0%, #65A30D 100%)"
        },
        {
          number: "03",
          title: "SAP BOBJ & LUMIRA",
          color: "#F59E0B",
          gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)"
        },
        {
          number: "04",
          title: "SAP Cloud, IOT, & DIBo",
          color: "#EF4444",
          gradient: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)"
        },
        {
          number: "05",
          title: "SAP HCM & Success Factor",
          color: "#475569",
          gradient: "linear-gradient(135deg, #475569 0%, #334155 100%)"
        }
      ]
    }
  },

  // Cloud & Big Data Carousel Section
  cloudBigDataCarousel: {
    cloudSolutions: {
      title: "Cloud Solutions",
      logos: [
        { name: "AWS", icon: "fab fa-aws", color: "#FF9900" },
        { name: "Azure", icon: "fab fa-microsoft", color: "#0089D6" },
        { name: "Google Cloud", icon: "fab fa-google", color: "#4285F4" },
        { name: "Salesforce", icon: "fab fa-salesforce", color: "#00A1E0" },
        { name: "Oracle Cloud", icon: "fas fa-cloud", color: "#F80000" },
        { name: "Linode", icon: "fab fa-linode", color: "#00A95C" },
        { name: "DigitalOcean", icon: "fab fa-digital-ocean", color: "#0080FF" },
        { name: "Heroku", icon: "fas fa-server", color: "#430098" },
        { name: "VMware", icon: "fas fa-cube", color: "#607078" },
        { name: "CloudFlare", icon: "fab fa-cloudflare", color: "#F38020" },
        { name: "Alibaba Cloud", icon: "fas fa-cloud-upload-alt", color: "#FF6A00" },
        { name: "ServiceNow", icon: "fas fa-cogs", color: "#62D84E" }
      ]
    },
    bigDataTools: {
      title: "Big Data & Analytics Tools",
      logos: [
        { name: "Python", icon: "fab fa-python", color: "#3776AB" },
        { name: "R", icon: "fab fa-r-project", color: "#276DC3" },
        { name: "TensorFlow", icon: "fas fa-brain", color: "#FF6F00" },
        { name: "Jupyter", icon: "fas fa-book", color: "#F37626" },
        { name: "Apache Spark", icon: "fas fa-fire", color: "#E25A1C" },
        { name: "Hadoop", icon: "fas fa-database", color: "#66CCFF" },
        { name: "Kafka", icon: "fas fa-stream", color: "#231F20" },
        { name: "Airflow", icon: "fas fa-wind", color: "#017CEE" },
        { name: "Tableau", icon: "fas fa-chart-line", color: "#E97627" },
        { name: "Power BI", icon: "fas fa-chart-bar", color: "#F2C811" },
        { name: "D3.js", icon: "fas fa-project-diagram", color: "#F9A03C" },
        { name: "Looker", icon: "fas fa-eye", color: "#4285F4" },
        { name: "Snowflake", icon: "fas fa-snowflake", color: "#29B5E8" },
        { name: "MongoDB", icon: "fas fa-leaf", color: "#47A248" },
        { name: "Redis", icon: "fas fa-layer-group", color: "#DC382D" }
      ]
    }
  },

  // Industries Section
  industries: {
    title: "Our Industry",
    subtitle: "Serving diverse sectors with specialized expertise",
    description: "From private enterprises to public institutions, we deliver tailored solutions across multiple industries with deep domain knowledge.",
    sectors: [
      {
        id: 1,
        name: "Private Sector",
        color: "#3B82F6",
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
        industries: [
          { name: "Health Care", icon: "fa-heartbeat" },
          { name: "Utilities", icon: "fa-bolt" },
          { name: "Auto", icon: "fa-car" },
          { name: "Oil & Gas", icon: "fa-oil-can" },
          { name: "Pharma", icon: "fa-pills" },
          { name: "Food", icon: "fa-utensils" },
          { name: "Retail", icon: "fa-shopping-cart" },
          { name: "Chemical", icon: "fa-flask" },
          { name: "Aprial", icon: "fa-industry" }
        ]
      },
      {
        id: 2,
        name: "Public Sector",
        color: "#F97316",
        gradient: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
        industries: [
          { name: "US Army", icon: "fa-shield-alt" },
          { name: "US Air Force", icon: "fa-plane" },
          { name: "DOD / LMP", icon: "fa-flag-usa" },
          { name: "DOT Hawaii", icon: "fa-road" },
          { name: "Aerospace", icon: "fa-rocket" },
          { name: "Local & State Govt.", icon: "fa-landmark" },
          { name: "Higher Ed", icon: "fa-graduation-cap" }
        ]
      }
    ]
  },

  // Development Methods Section
  developmentMethods: {
    title: "Our Development Methodology",
    subtitle: "Agile practices that deliver results",
    description: "We embrace modern development practices to ensure rapid delivery, continuous improvement, and exceptional quality in every project.",
    methods: [
      {
        id: 1,
        icon: "fa-sync-alt",
        title: "Iterative & Incremental Development",
        shortTitle: "Iterative Dev",
        description: "Building software in small, manageable increments with continuous feedback loops to adapt quickly to changing requirements.",
        color: "#F97316",
        gradient: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
        features: [
          "Continuous improvement cycles",
          "Regular feedback integration",
          "Risk mitigation through iterations",
          "Flexible scope management"
        ]
      },
      {
        id: 2,
        icon: "fa-layer-group",
        title: "Phased Delivery",
        shortTitle: "Phased Delivery",
        description: "Structured release cycles that deliver value incrementally, ensuring each phase meets quality standards before progression.",
        color: "#3B82F6",
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
        features: [
          "Milestone-based releases",
          "Quality gates at each phase",
          "Early value realization",
          "Reduced time-to-market"
        ]
      },
      {
        id: 3,
        icon: "fa-users-cog",
        title: "Daily Scrum",
        shortTitle: "Daily Scrum",
        description: "15-minute daily stand-ups to synchronize activities, identify blockers, and ensure team alignment on project goals.",
        color: "#F97316",
        gradient: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
        features: [
          "Daily team synchronization",
          "Immediate blocker resolution",
          "Enhanced transparency",
          "Rapid decision making"
        ]
      }
    ]
  },
};

export default companyConfig;
